import UpdateBgmeaUdExportPermissionCost from "../Update";

const ViewBgmeaUdExportPermissionCost = (props) => {
  return <UpdateBgmeaUdExportPermissionCost {...props} viewMode={true} />;
};

export default ViewBgmeaUdExportPermissionCost;
